import React from 'react';
import { AppBar, Tabs, Tab } from '@mui/material';
import { ReactComponent as LongerRed } from '../../assets/DuPont_Icon_Longer_red.svg'; 
import EnergySavingsLeaf  from '../../assets/DuPont_icon_green_energy_red.svg';
import EnvironmentResistence  from '../../assets/DuPont_Icon_Environmental_Resistance_red.svg';
import '../CustomAppBar/CustomNavigationBar.css';
import { styled } from '@mui/material/styles';

//Custom style for the AppBar
const CustomAppBar = styled(AppBar)({
  backgroundColor: 'white',
  color: 'black',
  boxShadow: '20px',
  borderBottom: '1px solid #e0e0e0',
  
});

//custom style for the tabs
const CustomTabs = styled(Tabs)({
    '&.MuiTabs-indicator': {
      height: '5px',
    },
    padding: '0px',
  });
  
  const CustomTab = styled(Tab)({
  width: '450px',
  color: 'black',
  //overide font family
  fontFamily:'DiodrumSemibold',
  '&.Mui-selected': {
    color: 'black',
  },
  '&.MuiButtonBase-root-MuiTab-root': {
  padding: '0px',
  },
  fontSize: '24px',

});





function CustomNavigationBar({ onTabChange }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onTabChange(newValue);
  };

  return (
    <CustomAppBar position="static" color="inherit" >
      <CustomTabs 
        variant='fullWidth' 
        value={value} 
        onChange={handleChange} 
        aria-label="navigation tabs" 
        textColor="inherit" // Use primary color for text
        centered
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: 'red',
            height: '5px',
            width: '100%',
          },
        }}
      >
        <CustomTab  label={"Estimated cost over time"} icon={<LongerRed width='50px' height='50px'/>}  iconPosition='end'/>
        <CustomTab label={"Reduced energy and operational footprint"} icon={<img src={EnergySavingsLeaf} alt="EnergySavingsLeaf" style={{width: '50px', height: '50px'}}/>}  iconPosition='end'/>
       <CustomTab label={"Environmental resistance"} icon={<img src={EnvironmentResistence} alt="EnvironmentResistence" style={{width: '50px', height: '50px'}}/>}  iconPosition='end'/>

      </CustomTabs>
    </CustomAppBar>
    );
}

export default CustomNavigationBar;